/**
 * Web component: Blog Text (blog-text)
 * -----------------------------------------------------------------------------
 * Renders additional rich text content for blog posts.
 *
 */
import './blog-text.scss';

import { vueReady } from '~/core/runners';

const selectors = {
  content: '[js-blog-text="content"]',
};

/**
 * Create new <blog-text> custom element.
 */
class BlogText extends HTMLElement {
  static observedAttributes = [];

  /**
   * Custom element constructor.
   * - Always call super first in constructor.
   */
  constructor() {
    super();

    this.elements = {
      content: this.querySelector(selectors.content),
    };

    this.headings = [];
    this.template = '';
  }

  /**
   * Lifecycle hook - component is attached to DOM.
   */
  connectedCallback() {
    this.updateToc();
  }

  /**
   * Build table of contents.
   */
  updateToc() {
    this.headings = [
      ...this.elements.content.querySelectorAll('h2, h3, h4, h5, h6'),
    ];

    for (const element of this.headings) {
      if (!element.innerText) {
        continue;
      }
    }

    cnvs.EventBus.emit('blog-page', {
      headlines: this.headings,
    });
  }
}

/**
 * Define web component on Vue initialisation.
 */
vueReady(() => {
  if (customElements.get('blog-text')) {
    return;
  }

  customElements.define('blog-text', BlogText);
});
